import React from "react";
import ProductCard from "../components/ProductCard";
import Layout from "../components/Layout";
import styles from "./Pineapple.module.css";
import { useLanguage } from "../i18n/LanguageContext";

const Juise = () => {
  const { t } = useLanguage();

  const juiseProducts = [
    {
      title: t("juice.products.lemon.title"),
      image: "/assets/products/juice/lemon-220.png",
      weight: t("juice.products.lemon.weight"),
      description: t("juice.products.lemon.description"),
    },
    {
      title: t("juice.products.lime.title"),
      image: "/assets/products/juice/lime-220.png",
      weight: t("juice.products.lime.weight"),
      description: t("juice.products.lime.description"),
    },
  ];

  return (
    <Layout>
      <h2 className={styles.heading}>{t("juice.title")}</h2>

      <div className={styles.grid}>
        {juiseProducts.map((p, i) => (
          <ProductCard key={i} {...p} />
        ))}
      </div>
    </Layout>
  );
};

export default Juise;
